import React, { Component } from 'react'

export default class SelectProvider extends Component {
  render() {
    let { children } = this.props

    return <React.Fragment>{children}</React.Fragment>
  }
}
